exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2{\n  text-align: center;\n  font-family: 'PT Sans', sans-serif;\n}\n.contact-form {\n  padding: 2em;\n  border: 1px solid black;\n  border-radius: 1%;\n}\n.container {\n  text-align: center;\n  width: 100%;\n  -webkit-box-flex: 0;\n      -ms-flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ];\n          flex: none | [ <'flex-grow'> <'flex-shrink'>? || <'flex-basis'> ];\n  padding-bottom: 25px;\n}\n\ntextarea {\n  height: 20%;\n  border: 1px solid #e8e9eb;\n}\n\n#signature{\n  width: 200px;\n  height: 50px;\n  padding-bottom: 2%;\n}\n@media only screen and (max-width: 749px){p{font-size:0.9375em}}\n.grid--half-gutters>.grid__item {\n    padding-left: 15px;\n}\n.grid__item{\n  float: left;\n  padding-left: 30px;\n}\nlabel {\n    display: block;\n    margin-bottom: 5px;\n}\n\ninput, select {\n    border: 1px solid #e8e9eb;\n    background-color: #fff;\n    max-width: 100%;\n    line-height: 1.2;\n    border-radius: 2px;\n    font-family: \"PT Serif\",serif;\n    color: #788188;\n    margin: 0 0 19.44444px;\n}\nbody, input, textarea, button, select, p {\n    font-size: 16px;\n    font-family: \"PT Serif\",serif;\n    color: #3d4246;\n    line-height: 1.5;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/contact/contact.component.css
// module id = 375
// module chunks = 1